import { ResponsiveGridLayout, useContainerWidth } from 'react-grid-layout';
import { transformStrategy } from 'react-grid-layout/core';
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

import GridWidget from './GridWidget';
import styled from 'styled-components';

const Grid = styled(ResponsiveGridLayout)`
  position: relative;
  transition: height 200ms ease;

  .react-grid-item > .react-resizable-handle {
    opacity: ${({ $isResizable }) => $isResizable ? '1' : '0'};
    pointer-events: ${({ $isResizable }) => $isResizable ? 'auto' : 'none'};
    position: absolute;
    width: 40px;
    height: 40px;
    background: transparent;  
}

  .react-grid-item > .react-resizable-handle::after {
    content: "";
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 10px;
    height: 10px;
    border-right: 2px solid ${({ theme }) => theme.font.color};
    border-bottom: 2px solid ${({ theme }) => theme.font.color};
  }

  .drag-handle {
    cursor: ${({ $isDraggable }) => $isDraggable ? 'grab' : 'default'};
  }
`;

const GridLayout = ({
  layouts,
  onLayoutChange,
  widgetArray,
  isResizable,
  isDraggable,
  handleDelete,
  setup,
}) => {
  const { width, containerRef, mounted } = useContainerWidth();

  return (
    <div ref={containerRef}>
      {mounted && (
        <Grid
          className="layout"
          width={width}
          breakpoints={setup.breakpoints}
          cols={setup.cols}
          margin={setup.margin}
          rowHeight={setup.rowHeight}
          layouts={layouts}
          onLayoutChange={onLayoutChange}
          dragConfig={{ enabled: isDraggable, handle: '.drag-handle', threshold: 5 }}
          resizeConfig={{ enabled: isResizable, handles: ['se'] }}
          positionStrategy={transformStrategy}
          $isDraggable={isDraggable}
          $isResizable={isResizable}
        >
          {widgetArray?.map((widget) => (
            <GridWidget
              key={widget.i}
              type={widget.type}
              isDraggable={isDraggable}
              handleDelete={handleDelete}
              widget={widget}
            />
          ))}
        </Grid>
      )}
    </div>
  );
};

export default GridLayout;
